import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import serviceImage1 from '../Images/businessmen-hands-white-table-with-documents-drafts.jpg'; // replace with your actual image
import serviceImage2 from '../Images/high-angle-measuring-tools-desk-still-life.jpg'; // replace with your actual image

import { FaPhoneAlt } from 'react-icons/fa';

import fixedFeeImg from '../Images/FixedFeeProject.png';
import hourlyImg from '../Images/hourlymodel.png';
import dedicatedTeamImg from '../Images/decteam.png';

import "./ContactCard.css";

import { motion } from "framer-motion";
import { AppConstant } from '../AppConstant';
import Header from '../Components/Header';
import Footer from '../Components/Footer';

const BusinessModels = () => {

  const navigate = useNavigate();

  const [showNumber, setShowNumber] = useState(false);

  const [showIndia, setShowIndia] = useState(false);
  const [showUSA, setShowUSA] = useState(false);

  const handleRevealIndia = () => setShowIndia(true);
  const handleRevealUSA = () => setShowUSA(true);

  const handleReveal = (e) => {
    e.stopPropagation(); // prevent triggering dial
    setShowNumber(true);
  };

  const handleDial = () => {
    if (showNumber) {
      window.location.href = "tel:+919860099980";
    }
  };
  const goToContact = () => {
    navigate('/Contact');
  };

  const businessData = [
    {
      title: "Engineering Services to Structural Engineering Firms",
      text: "In developed countries like the USA, skilled employees and other resources are costly, which can reduce profit margins. StructGuard Engineers LLP helps firms maintain higher profitability without compromising quality. Acting as an extended arm of your firm, we ensure seamless collaboration, timely delivery, and error-free results. Our services include structural analysis, BIM modeling, and drafting for residential, commercial, and industrial projects, improving efficiency at every stage.",
      image: serviceImage2,
    },
    {
      title: "Engineering Services to Owners, Architects, General Contractors, and Fabricators",
      text: "StructGuard Engineers LLP strives to keep clients happy and projects on track. We are associated with Licensed Professional Engineers (PE) in over 35 US states. Our services include structural analysis, design validation, connection detailing, and construction documentation, customized for owners, architects, contractors, and fabricators. By leveraging modern software and engineering practices, we help bring complex projects to life efficiently and safely.",
      image: serviceImage1,
    },
  ];

  return (
    <>
      <Header />
      <div style={styles.container}>

        {/* <h2 style={styles.heading}>
        Our Business <span style={styles.orangeText}> Module</span>
      </h2> */}


        {/* Section 1: */}
        {/* <div style={styles.section}>
        <img src={serviceImage2} alt="Engineering Services" style={styles.backgroundImage} />
        <div style={styles.overlayCardRight}>
          <strong style={styles.heading2}>Engineering Services to Structural Engineering firms</strong>
          <p style={styles.paragraph}>
            In a developed country like the USA, skilled employees and other resources are costly which brings down the total profit margin.
            <strong> StructGuard Engineers LLP </strong> helps you to keep profitability higher without compromising the quality...
            <br /><br />
            We act as an extended arm of your firm — ensuring seamless collaboration, timely delivery, and error-free results.
          </p>
        </div>
      </div>


   
      <div style={styles.section}>
        <img src={serviceImage1} alt="Engineering Services" style={styles.backgroundImage} />
        <div style={styles.overlayCard}>
          <strong style={styles.heading2}>Engineering Services to Owners, Architects, General Contractors, Fabricators</strong>
          <p style={styles.paragraph}>
            <p style={styles.paragraph}>
              StructGuard Engineers LLP always gives its best to keep our clients happy and satisfied. We have an association with the Licensed Professional Engineer (PE) in the USA with the license in 35+ states, a list of the same can be shared if required...
              <br /><br />
              We provide structural analysis, design validation, connection detailing, and construction documentation services tailored to meet the project-specific needs of owners and AEC professionals.
              <br /><br />
            </p>
          </p>
        </div>
      </div> */}


        <motion.h2
          style={{ color: "#0A1733", fontSize: '60px', alignSelf: 'center', textAlign: 'center' }}
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Our  <span style={{ color: '#f37021' }}>BuildMap</span>
        </motion.h2>

        <motion.p
          style={styles.subheading}
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.15, duration: 0.6 }}
        >
          Providing Structural Engineering Services to Firms and Project Stakeholders Across the World
        </motion.p>

        <div style={{ margin: "0 auto", padding: "50px 0", display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "40px" }}>

          {businessData.map((item, index) => (
            <div
              key={index}
              style={{
                flex: "1 1 400px",
                borderRadius: "15px",
                boxShadow: "0 8px 25px black",
                overflow: "hidden",
                transition: "transform 0.3s, box-shadow 0.3s",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-10px)";
                e.currentTarget.style.boxShadow = "0 15px 35px black";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 25px rgba(0,0,0,0.1)";
              }}
            >
              <img
                src={item.image}
                alt={item.title}
                style={{ width: "100%", height: "250px", objectFit: "cover", }}
              />
              <div style={{ padding: "25px", backgroundColor: "#fff" }}>
                <h2 style={{ fontSize: "24px", marginBottom: "15px", color: "#333" }}>{item.title}</h2>
                <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#555",  }}>{item.text}</p>
              </div>
            </div>
          ))}


        </div>



        {/* <div style={styles.contactCard}>
        <div style={styles.phoneBox}>

          <FaPhoneAlt style={styles.phoneIcon} />
          <div>
            <div style={styles.callLabel}>Call to ask any question</div>
            <div style={styles.phoneText}>+91 9860099980 /9158337666 </div>
          </div>
        </div>

        <div style={styles.subheading}>We offer flexible working models tailored to your needs</div>
      </div> */}

        {/* <div style={styles.contactCard}>
          <div className="phone-box" onClick={handleReveal}>
            <FaPhoneAlt className="phone-icon bounce" />
            <div>
              <div className="call-label slide">Call to ask any question</div>
              <div className={`phone-text ${showNumber ? "fade-in" : "hidden"}`}>
                +91 9860099980 / 9158337666
              </div>
              {!showNumber && <div className="phone-text pulse">Click to Contact</div>}
            </div>
          </div>
          <div className="subheading slide-up">
            We offer flexible working models tailored to your needs
          </div>
        </div> */}


        <div style={styles.contactCard}>

          {/* <div className="phone-box" onClick={handleRevealIndia}>
            <FaPhoneAlt className="phone-icon bounce" />
            <div>
              <div className="call-label slide">Call India Office</div>
               <div  className={`phone-text ${showIndia ? "fade-in" : "hidden"}`}>
                +91 9860099980
              </div> 
              {!showIndia && <div className="phone-text pulse">Click to Contact</div>}
            </div>
          </div> */}

          <div className="phone-box" onClick={handleRevealIndia}>
            <FaPhoneAlt className="phone-icon bounce" />
            <div>
              <div className="call-label slide">Call India Office</div>

              {/* When revealed */}
              {showIndia ? (
                <a
                  href="tel:+919860099980"
                  className="phone-text fade-in"
                  style={{
                    textDecoration: "none", color: "#f37021", fontWeight: "bold", borderBottom: "2px solid #f37021", // custom underline
                    paddingBottom: "2px",
                  }}
                >
                  +91 986 0099 980
                </a>
              ) : (
                <div className="phone-text pulse">Click to Contact</div>
              )}
            </div>
          </div>

          <div className="phone-box" onClick={handleRevealUSA}>
            <FaPhoneAlt className="phone-icon bounce" />

            <div>
              <div className="call-label slide">Call USA Office</div>

              {showUSA ? (
                <a
                  href="tel:+13144793530"
                  className="phone-text fade-in"
                  style={{
                    textDecoration: "none", color: "#f37021", fontWeight: "bold", borderBottom: "2px solid #f37021", // custom underline
                    paddingBottom: "2px",
                  }}
                >
                  +1 314 479 3530
                </a>
              ) : (
                <div className="phone-text pulse">Click to Contact</div>
              )}




            </div>

          </div>

          <div className="subheading slide-up">
            We offer flexible working models tailored to your needs
          </div>
        </div>


        <div style={styles.divider}></div>

        <div style={styles.cards}>
          <div style={styles.card}>
            <img src={fixedFeeImg} alt="Fixed Fee" style={styles.cardImage} />
            <h3 style={styles.cardTitle}>📦 Fixed Fee Project</h3>
            <p style={styles.cardText}>
              Preferred when the scope of work is clear. We quote the project based on detailed client requirements for better predictability.
            </p>
          </div>

          <div style={styles.card}>
            <img src={hourlyImg} alt="Hourly Model" style={styles.cardImage} />
            <h3 style={styles.cardTitle}>⏱️ Hourly Model</h3>
            <p style={styles.cardText}>
              Used for larger projects with evolving scope. Work proceeds based on a mutually agreed hourly rate.
            </p>
          </div>

          <div style={styles.card}>
            <img src={dedicatedTeamImg} alt="Dedicated Team" style={styles.cardImage} />
            <h3 style={styles.cardTitle}>👥 Dedicated Team</h3>
            <p style={styles.cardText}>
              A focused team dedicated entirely to your projects ensuring alignment, speed, and exclusive support.
            </p>
          </div>
        </div>









        {/* <div style={styles.cards}>
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>📦 Fixed Fee Project</h3>
          <p style={styles.cardText}>
            Preferred when the scope of work is clear. We quote the project based on detailed client requirements for better predictability.
          </p>
        </div>

        <div style={styles.card}>
          <h3 style={styles.cardTitle}>⏱️ Hourly Model</h3>
          <p style={styles.cardText}>
            Used for larger projects with evolving scope. Work proceeds based on a mutually agreed hourly rate.
          </p>
        </div>

        <div style={styles.card}>
          <h3 style={styles.cardTitle}>👥 Dedicated Team</h3>
          <p style={styles.cardText}>
            A focused team dedicated entirely to your projects ensuring alignment, speed, and exclusive support.
          </p>
        </div>
      </div> */}





      </div>
      <Footer />
    </>
  );
};

const styles = {
  container: {
    fontFamily: 'Segoe UI, sans-serif',
    padding: '3rem 2rem',
    // backgroundColor: '#f9fafc',
    // backgroundImage: AppConstant.backgroundtextilerdesign,
    // backgroundAttachment: AppConstant.backgroundAttachmentscroller,
    background: 'white',
    // background: 'linear-gradient(to right, #0A1733, #1D2D50, #F37021)', 
    // background: 'linear-gradient(to right, #0f2027, #203a43, #2c5364)',
    minHeight: '100vh',
  },
  cardImage: {
    width: '300px',       // adjust size as needed
    height: '300px',
    objectFit: 'contain',
    marginBottom: '1rem',

  },

  heading: {
    fontSize: '26px',
    fontWeight: 'bold',
    color: "#0A1733"
  },
  sectionTitle: {
    color: 'orange',
    fontWeight: 'bold',
    fontSize: '1.3rem',
    marginBottom: '1.5rem',
  },
  textBlock: {
    color: '#333',
    lineHeight: '1.7',
    marginBottom: '1.5rem',
    fontSize: '0.98rem',
  },
  contactCard: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    background: 'white',
    backdropFilter: 'blur(10px)',
    borderRadius: '20px',
    padding: '25px 35px',
    gap: '25px',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    marginTop: '50px',
    marginBottom: '20px'
  },
  phoneLink: {
    display: "inline-block",
    color: "#f37021",
    fontWeight: "bold",
    fontSize: "1rem",
    textDecoration: "none", // remove default underline
    borderBottom: "2px solid #f37021", // custom underline
    paddingBottom: "2px",
    marginTop: "4px",
    cursor: "pointer",
  },

  phoneBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
  },

  phoneIcon: {
    fontSize: '28px',
    backgroundColor: '#f37021',
    color: 'white',
    borderRadius: '50%',
    padding: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  callLabel: {
    color: '#ccc',
    fontSize: '14px',
  },

  phoneText: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#0A1733',
  },

  button: {
    padding: '12px 30px',
    backgroundColor: '#ffc107',
    color: '#212121',
    border: 'none',
    borderRadius: '30px',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: 'bold',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
  },

  subheading: {
    maxWidth: 940,
    margin: "12px auto 32px",
    fontSize: '1rem',
    textAlign: 'center',
    marginBottom: '40px',
    fontWeight: "bold",
    fontStyle: 'italic',
    marginLeft: 'auto',
    marginRight: 'auto',
    // color: 'lightgrey',
    color: '#0A1733',
    // textTransform: "capitalize",

    // textDecoration: "underline 2px rgb(255, 101, 0)",

    textUnderlineOffset: "10px",
    letterSpacing: "2px",
  },
  divider: {
    width: '50px',
    height: '4px',
    backgroundColor: 'red',
    margin: '0 auto 2rem',
    borderRadius: '2px',
  },
  cards: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '2rem',
    marginTop: '40px',
  },

  card: {
    flex: '1 1 300px',
    background: 'linear-gradient(145deg, rgba(255,255,255,0.1), rgba(255,255,255,0.05))',
    border: '1px solid rgba(255,255,255,0.15)',
    borderRadius: '20px',
    padding: '2rem',
    textAlign: 'center',
    boxShadow: '0 8px 20px rgba(0,0,0,0.1)',
    backdropFilter: 'blur(8px)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

  },

  cardTitle: {
    fontSize: '1.4rem',
    fontWeight: '700',
    color: '#0A1733',
    marginBottom: '1rem',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },

  cardText: {
    fontSize: '1rem',
    color: 'grey',
    lineHeight: '1.6',
    // textTransform: "capitalize",
  },

  // Add hover effect with JS-in-style or a className:
  '@media (hover: hover)': {
    card: {
      ':hover': {
        transform: 'translateY(-8px)',
        boxShadow: '0 12px 30px rgba(0,0,0,0.15)',
      },
    },
  },

  orangeText: {
    color: '#f37021',
  },

  section: {
    position: 'relative',
    width: '100%',
    height: '400px',
    marginBottom: '60px',
    overflow: 'hidden',
    borderRadius: '20px',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
  },
  backgroundImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    filter: 'brightness(0.7)',
  },
  overlayCard: {
    position: 'absolute',
    top: '50%',
    left: '10%',
    transform: 'translateY(-50%)',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    backdropFilter: 'blur(10px)',
    padding: '30px',
    borderRadius: '16px',
    color: '#fff',
    width: '35%',
    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.3)',
  },
  overlayCardRight: {
    position: 'absolute',
    top: '50%',
    right: '10%',
    transform: 'translateY(-50%)',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    backdropFilter: 'blur(10px)',
    padding: '30px',
    borderRadius: '16px',
    color: '#fff',
    width: '35%',
    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.3)',
  },

  heading2: {
    fontSize: '22px',
    fontWeight: '600',
    marginBottom: '15px',
    color: 'black',
  },
  paragraph: {
    fontSize: '14px',
    color: '#ddd',
    lineHeight: '1.6',
  },
};

export default BusinessModels;
